var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFabrica = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_1033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7347 11.1967C36.4977 6.607 38.6939 0.995416 43.7766 0.179675C48.8862 -0.967741 53.0186 3.54125 53.44 8.31019C56.5774 9.49347 59.8494 11.0981 61.3553 14.2983C64.0087 18.7624 61.1402 24.5354 64.1163 28.883C66.8862 33.392 73.6901 30.7655 76.451 35.2655C79.0148 39.3442 77.6791 44.4359 77.9481 48.9807C75.9042 48.9449 73.8694 48.9538 71.8255 48.9807C71.1711 45.4757 70.0775 41.7018 66.949 39.5952C63.193 36.4488 57.7069 38.1251 53.7537 35.4448C51.8712 34.2615 50.6431 32.3342 49.1909 30.7207C44.5744 30.9179 39.4738 29.7884 36.8741 25.6111C33.6112 21.2545 34.6241 15.2933 37.7437 11.1698L37.7347 11.1967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3509 52.6469C72.8022 52.6469 76.2444 52.611 79.6956 52.6379C79.7046 63.5742 79.6956 74.5195 79.6956 85.4648C76.2444 85.4737 72.7932 85.4469 69.333 85.4648C69.342 74.5195 69.333 63.5832 69.342 52.6559L69.3509 52.6469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0220097 73.6856C9.16548 69.7145 18.3 65.6716 27.4883 61.7363C27.4972 64.578 27.4883 67.4196 27.4972 70.2523C34.0411 67.4555 40.5491 64.56 47.093 61.7632C47.1109 64.6049 47.1198 67.4555 47.1467 70.2971C53.6637 67.4286 60.2165 64.6049 66.7425 61.7543C66.7783 69.6607 66.7514 77.5492 66.7514 85.4556C44.5023 85.4556 22.2442 85.4556 -0.00488281 85.4556C-0.00488281 81.5382 0.0309739 77.6029 0.0130456 73.6856H0.0220097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_1033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.6997,
    height: 85.4646,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFabrica);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FABRICA.5086c5cd82075be3babb1ae96509ec74.svg";